import { useEffect, useState } from "react";
import Table from "../components/Table";
import Modal from "../components/Modal";
import FotoUpload from "../components/FotoUpload";
import Form from "../components/Form";
import ModalChecklist from '../components/ModalChecklist';
import ModalVerPDF from "../components/ModalVerPDF";
import ModalVacaciones from '../components/ModalVacaciones';
import ModalReporteVacaciones from '../components/ModalReporteVacaciones';

const API_URL = process.env.REACT_APP_API_URL;

const ESTADO_INICIAL = {
    id: null, nombre_completo: '', usuario: '', puesto: '', contrasena: '',
    email: '', tel_ext: '', celular_id: null, area_id: null, sucursal_id: null,
    rol: 'usuario', activo: true, fecha_ingreso: null,
    foto_file: null, foto_preview: null, num_corp: '', titulo: '', jefe_id: null,
    fecha_vacaciones: null
};

export default function UsuariosScreen({ token, currentUser }) {
    const [usuarios, setUsuarios] = useState([]);
    const [areas, setAreas] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [celulares, setCelulares] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [showBajas, setShowBajas] = useState(false);
    const [showReporte, setShowReporte] = useState(false);
    const [usuarioForm, setUsuarioForm] = useState(ESTADO_INICIAL);
    const [usuarioParaBaja, setUsuarioParaBaja] = useState(null);
    const [usuarioVacaciones, setUsuarioVacaciones] = useState(null);
    const [showChecklist, setShowChecklist] = useState(false);
    const [modal, setModal] = useState({ visible: false, titulo: '', mensaje: '', tipo: 'info', onConfirm: null, onCancel: null });
    const isAdmin = currentUser?.rol === ('admin');
    const isRRHH = currentUser?.rol === ('rrhh');
    const isCelular = currentUser?.rol === 'celular';
    const isGerente = currentUser?.rol === 'gerente';

    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfTitulo, setPdfTitulo] = useState('');
    const [pdfRow, setPdfRow] = useState(null);

    const showModal = (tipo, titulo, mensaje, onConfirm = null, onCancel = null) =>
        setModal({ visible: true, tipo, titulo, mensaje, onConfirm, onCancel });
    const set = (campo) => (v) => setUsuarioForm(f => ({ ...f, [campo]: v }));
    const fotoUrl = (url) => url ? `${API_URL.replace('/api', '')}${url}` : null;

    // ── Carga ─────────────────────────────────────────────────────────────
    const cargar = async () => {
        setLoading(true);
        try {
            if (isCelular) {
                const id = currentUser.id;
                const [resU, resA, resS, resC] = await Promise.all([
                    fetch(`${API_URL}/usuarios/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
                    fetch(`${API_URL}/areas`, { headers: { Authorization: `Bearer ${token}` } }),
                    fetch(`${API_URL}/sucursales`, { headers: { Authorization: `Bearer ${token}` } }),
                    fetch(`${API_URL}/celulares`, { headers: { Authorization: `Bearer ${token}` } }),
                ]);
                const dataU = resU.ok ? await resU.json().catch(() => []) : [];
                const dataA = resA.ok ? await resA.json().catch(() => []) : [];
                const dataS = resS.ok ? await resS.json().catch(() => []) : [];
                const dataC = resC.ok ? await resC.json().catch(() => []) : [];
                setUsuarios(Array.isArray(dataU) ? dataU : []);
                setAreas(Array.isArray(dataA) ? dataA : []);
                setSucursales(Array.isArray(dataS) ? dataS : []);
                setCelulares(Array.isArray(dataC) ? dataC : []);
            } else {
                const [resU, resA, resS, resC] = await Promise.all([
                    fetch(`${API_URL}/usuarios`, { headers: { Authorization: `Bearer ${token}` } }),
                    fetch(`${API_URL}/areas`, { headers: { Authorization: `Bearer ${token}` } }),
                    fetch(`${API_URL}/sucursales`, { headers: { Authorization: `Bearer ${token}` } }),
                    fetch(`${API_URL}/celulares`, { headers: { Authorization: `Bearer ${token}` } }),
                ]);
                const dataU = await resU.json().catch(() => []);
                const dataA = resA.ok ? await resA.json().catch(() => []) : [];
                const dataS = resS.ok ? await resS.json().catch(() => []) : [];
                const dataC = resC.ok ? await resC.json().catch(() => []) : [];
                setUsuarios(Array.isArray(dataU) ? dataU : []);
                setAreas(Array.isArray(dataA) ? dataA : []);
                setSucursales(Array.isArray(dataS) ? dataS : []);
                setCelulares(Array.isArray(dataC) ? dataC : []);
            }
        } catch {
            showModal("error", "Error", "No se pudieron cargar los datos");
        } finally {
            setLoading(false);
            setShowBajas(false);
        }
    };
    useEffect(() => { cargar(); }, []);
    const cargarBajas = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_URL}/usuarios/bajas`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setUsuarios(await res.json());
        } catch {
            showModal("error", "Error", "No se pudieron cargar las bajas");
        } finally {
            setLoading(false);
        }
    };


    // ── Handlers ──────────────────────────────────────────────────────────
    const abrirEditar = (row) => {
        setUsuarioForm({ ...ESTADO_INICIAL, ...row, contrasena: '', foto_file: null, foto_preview: fotoUrl(row.foto_url), fecha_ingreso: row.fecha_ingreso ? row.fecha_ingreso.split('T')[0] : null, fecha_vacaciones: row.fecha_vacaciones ? row.fecha_vacaciones.split('T')[0] : null });
        setShowForm(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const abrirNuevo = () => { setUsuarioForm(ESTADO_INICIAL); setShowForm(true); };

    const cerrarForm = () => { setShowForm(false); setUsuarioForm(ESTADO_INICIAL); };

    const handleSubirFoto = async (id, archivo) => {
        const formData = new FormData();
        formData.append('foto', archivo);
        await fetch(`${API_URL}/usuarios/${id}/foto`, {
            method: 'PUT',
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
        });
    };

    const handleGuardar = (e) => {
        e.preventDefault();
        showModal(
            'confirm',
            '¿Enviar correo?',
            '¿Deseas enviar notificación por correo al usuario?',
            async () => await guardarUsuario(true),  // Sí
            async () => await guardarUsuario(false) // No
        );
    };

    const guardarUsuario = async (enviarCorreo) => {
        try {
            const { foto_file, foto_preview, ...resto } = usuarioForm;
            const esEdicion = !!usuarioForm.id;

            if (esEdicion && !resto.contrasena) delete resto.contrasena;

            const res = await fetch(
                esEdicion
                    ? `${API_URL}/usuarios/${usuarioForm.id}`
                    : `${API_URL}/usuarios`,
                {
                    method: esEdicion ? 'PUT' : 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        ...resto,
                        enviarCorreo
                    })
                }
            );

            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message);

            if (foto_file) {
                await handleSubirFoto(data.id ?? usuarioForm.id, foto_file);
            }

            cerrarForm();
            cargar();

            showModal(
                'success',
                'Listo',
                esEdicion ? 'Usuario actualizado' : 'Usuario creado'
            );

        } catch (err) {
            showModal('error', 'Error', err.message);
        }
    };

    const handleEliminar = (row) => {
        if (showBajas) {
            // Activar directamente
            showModal('confirm', '¿Activar usuario?', `Se activará a ${row.nombre_completo}`, async () => {
                try {
                    await fetch(`${API_URL}/usuarios/delete/${row.id}`, {
                        method: 'PUT', headers: { Authorization: `Bearer ${token}` }
                    });
                    cargar();
                    showModal('success', 'Listo', 'Usuario activado');
                } catch {
                    showModal('error', 'Error', 'No se pudo activar al usuario');
                }
            });
        } else {
            // Desactivar — primero confirmar, luego checklist
            showModal('confirm', '¿Desactivar usuario?', `Se desactivará a ${row.nombre_completo}`, async () => {
                try {
                    const res = await fetch(`${API_URL}/asignaciones/${row.id}/equipos-asignados`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    const equipos = res.ok ? await res.json().catch(() => []) : [];

                    const usuarioEnriquecido = {
                        ...row,
                        area_nombre: areas.find(a => a.id === row.area_id)?.nombre ?? '—',
                        sucursal_nombre: sucursales.find(s => s.id === row.sucursal_id)?.nombre ?? '—',
                        equiposAsignados: equipos,
                    };
                    setUsuarioParaBaja(usuarioEnriquecido);
                    setShowChecklist(true);
                } catch {
                    showModal('error', 'Error', 'No se pudieron cargar los equipos del usuario');
                }
            });
        }
    };

    const handleConfirmarChecklist = async (form) => {
        setShowChecklist(false);
        try {
            await fetch(`${API_URL}/usuarios/delete/${usuarioParaBaja.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ checklist: form })
            });
            setUsuarioParaBaja(null);
            cargar();
            showModal('success', 'Listo', 'Usuario desactivado y acta generada');
        } catch {
            showModal('error', 'Error', 'No se pudo desactivar al usuario');
        }
    };
    const handleResetear = (row) => {
        showModal('confirm', '¿Resetear contraseña?',
            `Se restablecerá la contraseña de ${row.nombre_completo} a "Temp123"`,
            async () => {
                try {
                    const res = await fetch(`${API_URL}/usuarios/${row.id}/reset-password`, {
                        method: 'PUT',
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    const data = await res.json().catch(() => ({}));
                    if (!res.ok) throw new Error(data.message);
                    showModal('success', 'Listo', `Contraseña reseteada. El usuario deberá cambiarla al iniciar sesión.`);
                } catch (err) {
                    showModal('error', 'Error', err.message);
                }
            }
        );
    };

    const handleDescargarPazYSalvo = async (row) => {
        try {
            const res = await fetch(`${API_URL}/usuarios/${row.id}/paz-y-salvo`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('No se encontró el archivo');
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = `paz_salvo_${row.nombre_completo}.pdf`; a.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            showModal('error', 'Error', err.message);
        }
    };

    const handleVerPDF = async (row) => {
        try {
            const res = await fetch(`${API_URL}/usuarios/ver/${row.id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('No se pudo cargar el documento');
            const blob = await res.blob();
            setPdfUrl(URL.createObjectURL(blob));
            setPdfTitulo(`Responsiva — ${row.usuario_nombre ?? ''}`);
            setPdfRow(row);
        } catch (err) {
            showModal('error', 'Error', err.message);
        }
    };

    const cerrarPDF = () => {
        URL.revokeObjectURL(pdfUrl);
        setPdfUrl(null);
        setPdfRow(null);
    };
    const handleDescargarDesdePDF = () => handleDescargarPazYSalvo(pdfRow);

    const handleCargaMasiva = async (e) => {
        const archivo = e.target.files[0];
        if (!archivo) return;
        const formData = new FormData();
        formData.append('csv', archivo);
        try {
            const res = await fetch(`${API_URL}/usuarios/carga-masiva`, {
                method: 'POST',
                headers: { Authorization: `Bearer ${token}` },
                body: formData
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message);
            cargar();
            showModal('success', 'Carga completada',
                `Creados: ${data.creados} | Omitidos (ya existían): ${data.omitidos}${data.errores.length > 0 ? ` | Errores: ${data.errores.length}` : ''}`
            );
        } catch (err) {
            showModal('error', 'Error', err.message);
        }
        e.target.value = '';
    };

    const formatFecha = (fecha) => {
        if (!fecha) return '—';
        const d = new Date(fecha);
        return `${String(d.getUTCDate()).padStart(2, '0')}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${d.getUTCFullYear()}`;
    };

    const formatearFechaRenovacion = (fechaISO) => {
        if (!fechaISO) return '';

        // Creamos la fecha indicando UTC para evitar que cambie el día por la zona horaria local
        const fecha = new Date(fechaISO);

        // Extraemos día y mes en español usando UTC
        const dia = fecha.getUTCDate().toString().padStart(2, '0');
        const meses = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];
        const mes = meses[fecha.getUTCMonth()];

        return `${dia} de ${mes}`;
    };

    // ── Config tabla ──────────────────────────────────────────────────────
    // Columnas normales
    const columnasActivos = [
        {
            header: 'Foto', render: (row) => (
                <FotoUpload foto={fotoUrl(row.foto_url)} nombre={row.nombre_completo}
                    onUpload={(archivo) => handleSubirFoto(row.id, archivo).then(cargar)} />
            )
        },
        { header: 'Nombre', accessor: 'nombre_completo' },
        { header: 'Usuario', accessor: 'usuario' },
        { header: 'Área', render: (row) => areas.find(a => a.id === row.area_id)?.nombre ?? '—' },
        { header: 'Sucursal', render: (row) => sucursales.find(s => s.id === row.sucursal_id)?.nombre ?? '—' },
        ...(!isAdmin && !isRRHH && !isGerente ? [{
            header: 'Vacaciones', render: (row) => (
                <div className="acciones-celda">
                    <button className="btn-secondary" style={{ fontSize: 12 }}
                    onClick={() => setUsuarioVacaciones(
                        row.id === currentUser.id ? currentUser : row
                    )}>
                    {row.id === currentUser.id ? 'Mis vacaciones' : 'Vacaciones'}
                    </button>
                </div>
            )
        }] : []),
        { header: 'F. Renovación Vacaciones', render: (row) => formatearFechaRenovacion(row.fecha_vacaciones) },
        ...((isAdmin || isRRHH || isGerente) ? [{
            header: 'Acciones', render: (row) => (
                <>
                    <button className="btn-edit" onClick={() => abrirEditar(row)}>Editar</button>
                    <button className="btn-secondary" style={{ fontSize: 12, padding: '5px 10px', background: '#17a2b8', color: 'white' }}
                        onClick={() => setUsuarioVacaciones(row)}>
                        Vacaciones
                    </button>
                    {isAdmin && (
                        <>
                            <button className="btn-secondary" style={{ fontSize: 12, padding: '5px 10px' }}
                                onClick={() => handleResetear(row)}>Reset contraseña</button>
                            <button className="btn-delete" onClick={() => handleEliminar(row)}>Desactivar</button>
                        </>)}
                </>
            )
        }] : []),
    ];

    // Columnas para bajas
    const columnasBajas = [
        { header: 'Nombre', accessor: 'nombre_completo' },
        { header: 'Área', render: (row) => areas.find(a => a.id === row.area_id)?.nombre ?? '—' },
        { header: 'Sucursal', render: (row) => sucursales.find(s => s.id === row.sucursal_id)?.nombre ?? '—' },
        { header: 'Fecha Ingreso', render: (row) => formatFecha(row.fecha_ingreso) },
        ...((isAdmin || isRRHH) ? [{
            header: 'Acciones',
            render: (row) => (
                <>
                    {isAdmin && (
                        <button className="btn-edit" style={{ background: '#28a745', color: 'white' }} onClick={() => handleEliminar(row)}>
                            Activar
                        </button>
                    )}
                    {(isRRHH || isAdmin) && (
                        <>
                            <button className="btn-edit" onClick={() => handleDescargarPazYSalvo(row)}>
                                Descargar documento
                            </button>
                            <button className="btn-edit" style={{ background: '#17a2b8', color: 'white' }}
                                onClick={() => handleVerPDF(row)}>
                                Ver
                            </button>
                        </>
                    )}
                </>
            )
        }] : []),
    ];

    // ── Config form ───────────────────────────────────────────────────────
    const campos = [
        {
            fullRow: true, render: () => (
                <FotoUpload foto={usuarioForm.foto_preview} nombre={usuarioForm.nombre_completo} editable
                    onUpload={(archivo) => setUsuarioForm(f => ({
                        ...f, foto_file: archivo, foto_preview: URL.createObjectURL(archivo)
                    }))} />
            )
        },
        { label: 'Nombre completo', value: usuarioForm.nombre_completo, onChange: set('nombre_completo'), required: true, placeholder: 'Nombre completo' },
        { label: 'Título', type: 'select', value: usuarioForm.titulo, onChange: set('titulo'), options: [{ value: '', label: '— Sin título —' }, { value: 'Lic.', label: 'Lic.' }, { value: 'Ing.', label: 'Ing.' }, { value: 'Mtro.', label: 'Mtro.' }, { value: 'Mtra.', label: 'Mtra.' }, { value: 'Dr.', label: 'Dr.' }, { value: 'Dra.', label: 'Dra.' }, { value: 'C.P.', label: 'C.P.' }, { value: 'Arq.', label: 'Arq.' },] },
        { label: 'Numero corporativo.', value: usuarioForm.num_corp, onChange: set('num_corp'), placeholder: 'Número Corporativo (Opcional)' },
        { label: 'Email', value: usuarioForm.email, onChange: set('email'), type: 'email', placeholder: 'Email (Opcional)' },
        { label: 'Teléfono ext.', value: usuarioForm.tel_ext, onChange: set('tel_ext'), placeholder: 'Ext. (Opcional)' },
        ...((isRRHH || isAdmin) ? [
            { label: 'Fecha Inicio de Vacaciones', value: usuarioForm.fecha_vacaciones, onChange: set('fecha_vacaciones'), type: 'date' },
        ] : []),
        ...(isAdmin ? [
            { label: 'Usuario', value: usuarioForm.usuario, onChange: set('usuario'), required: true, placeholder: 'Nombre de usuario' },
            { label: 'Puesto', value: usuarioForm.puesto, onChange: set('puesto'), placeholder: 'Puesto (Opcional)' },
            { label: 'Fecha ingreso', value: usuarioForm.fecha_ingreso, onChange: set('fecha_ingreso'), type: 'date' },
            {
                label: 'Área', type: 'select', value: usuarioForm.area_id, onChange: set('area_id'),
                options: [
                    { value: '', label: '-- Selecciona --' },
                    ...areas.map(a => ({
                        value: a.id,
                        label: `${sucursales.find(s => s.id === a.sucursal_id)?.nombre ?? '?'} - ${a.nombre}`
                    }))
                ]
            },
            {
                label: 'Sucursal', type: 'select', value: usuarioForm.sucursal_id, onChange: set('sucursal_id'),
                options: [{ value: '', label: '-- Selecciona sucursal --' }, ...sucursales.map(s => ({ value: s.id, label: s.nombre }))]
            },
            {
                label: 'Rol', type: 'select', value: usuarioForm.rol, onChange: set('rol'),
                options: [{ value: 'usuario', label: 'Usuario' }, { value: 'admin', label: 'Administrador' }, { value: 'gerente', label: 'Gerente' }, { value: 'celular', label: 'Admin de Celulares' }, { value: 'rrhh', label: 'Recursos Humanos' }]
            },
            {
                label: 'Activo', type: 'select', value: String(usuarioForm.activo), onChange: v => setUsuarioForm(f => ({ ...f, activo: v === 'true' })),
                options: [{ value: 'true', label: 'Sí' }, { value: 'false', label: 'No' }]
            },
            {
                label: 'Jefe directo', type: 'select', value: usuarioForm.jefe_id, onChange: set('jefe_id'),
                options: [
                    { value: '', label: '— Sin jefe asignado —' },
                    ...usuarios
                        .filter(u => u.id !== usuarioForm.id) // no puede ser su propio jefe
                        .sort((a, b) => a.nombre_completo.localeCompare(b.nombre_completo, 'es'))
                        .map(u => ({ value: u.id, label: u.nombre_completo }))
                ]
            },
        ] : []),
    ];

    // ── Render ────────────────────────────────────────────────────────────
    if (loading) return <p>Cargando...</p>;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {/* Cabecera de la sección con acciones */}
            <div className="section-header">
                <h2 style={{ margin: 0 }}>Usuarios</h2>

                <div className="section-actions">
                    {(isAdmin || isGerente || isRRHH) && (
                        <button className="btn-secondary btn-action" onClick={() => setShowReporte(s => !s)}>
                            {showReporte ? 'Ocultar reporte' : 'Reporte vacaciones'}
                        </button>
                    )}
                    {(isAdmin || isRRHH) && (
                        <button className="btn-secondary btn-action" onClick={() => {
                            if (showBajas) { setShowBajas(false); cargar(); }
                            else { setShowBajas(true); cargarBajas(); cerrarForm(); }
                        }}>
                            {showBajas ? 'Ver Usuarios' : 'Ver Inactivos'}
                        </button>
                    )}
                    {isAdmin && (
                        <button className="btn-primary btn-action" onClick={showForm ? cerrarForm : abrirNuevo}>
                            {showForm ? 'Cancelar' : 'Nuevo Usuario'}
                        </button>
                    )}
                </div>
            </div>

            {/* Carga masiva */}
            {isAdmin && (
                <div className="upload-container">
                    <label className="btn-secondary btn-upload">
                        📁 Carga masiva CSV
                        <input type="file" accept=".csv" style={{ display: 'none' }} onChange={handleCargaMasiva} />
                    </label>
                </div>
            )}

            {showForm && (
                <Form campos={campos} onSubmit={handleGuardar} onCancel={cerrarForm}
                    submitLabel={usuarioForm.id ? 'Actualizar Usuario' : 'Crear Usuario'} />
            )}

            <Table columnas={showBajas ? columnasBajas : columnasActivos} datos={usuarios} mensajeVacio="Sin usuarios registrados" />
            <Modal modal={modal} setModal={setModal} />
            <ModalChecklist
                usuario={showChecklist ? usuarioParaBaja : null}
                onConfirm={handleConfirmarChecklist}
                onClose={() => { setShowChecklist(false); setUsuarioParaBaja(null); }}
            />
            <ModalVerPDF
                url={pdfUrl}
                titulo={pdfTitulo}
                isAdmin={isAdmin}
                onDescargar={handleDescargarDesdePDF}
                onClose={cerrarPDF}
            />
            <ModalVacaciones
                usuario={usuarioVacaciones}
                token={token}
                onClose={() => setUsuarioVacaciones(null)}
                currentUser={currentUser}
            />
            {showReporte && (
                <ModalReporteVacaciones
                    token={token}
                    currentUser={currentUser}
                    onClose={() => setShowReporte(false)}
                />
            )}
        </div>
    );
}